<mat-slide-toggle
    #nativeElement
    [color]="asFormsControl().color || color"
    [checked]="asFormsControl().getChecked() || checked" 
    [disabled]="asFormsControl().disabled || disabled"
    (change)="changeValue($event)"
    [ngClass]="{'text-on-left': textOnLeft}"
    disableRipple
>
    {{ !nativeElement.checked ? texts[1] : texts[0] }}
</mat-slide-toggle>
